import _ from 'lodash';
import { normalize, schema } from 'normalizr';
import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const BASIC_RECORDS_LIST_SUCCESS =
  api.events.basicRecordsList.actionSuccess;
const BASIC_RECORDS_LATEST_SUCCESS =
  api.events.basicRecordsLatest.actionSuccess;
const BASIC_RECORDS_CREATE_SUCCESS =
  api.events.basicRecordsPost.actionSuccess;
const BASIC_RECORDS_PATCH_SUCCESS =
  api.events.basicRecordsPatch.actionSuccess;
const BASIC_RECORDS_DELETE_SUCCESS =
  api.events.basicRecordsDelete.actionSuccess;

const basicRecordSchema = new schema.Entity('basicRecords');

const basicRecordListSchema = new schema.Array(basicRecordSchema);

const defaultState = {};

export default function(state = defaultState, action) {
  switch (action.type) {
    case BASIC_RECORDS_LIST_SUCCESS: {
      const normalizedData = normalize(action.data, basicRecordListSchema);
      
      return {
        ...state,
        ...normalizedData.entities.basicRecords
      };
    }
    case BASIC_RECORDS_LATEST_SUCCESS: {
      const normalizedData = normalize(action.data, basicRecordListSchema);

      return {
        ...state,
        ...normalizedData.entities.basicRecords
      };
    }
    case BASIC_RECORDS_CREATE_SUCCESS: {
      return {
        ...state,
        [action.data.id]: action.data
      };
    }
    case BASIC_RECORDS_PATCH_SUCCESS: {
      return {
        ...state,
        [action.data.id]: action.data
      };
    }
    case BASIC_RECORDS_DELETE_SUCCESS: {
      const deletedId = action.request.pathvars.id;
      return _.omit(state, [deletedId]);
    }
    case LOGOUT_SUCCESS:
      return defaultState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/basicRecords.js